<template>
  <div>
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select
              v-model="searchForm.project"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择发布平台"
              style="width: 100%"
              @change="handleProjectChange"
            >
              <a-select-option v-for="item in lineListLv1" :key="item.project" :value="item.project">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="优惠码" prop="coupon_code">
            <a-input v-model="searchForm.coupon_code" allowClear placeholder="请输入优惠码" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="优惠券名称" prop="coupon_name">
            <a-input
              v-model="searchForm.coupon_name_keyword"
              allowClear
              placeholder="请输入优惠券名称"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>

        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态" prop="state">
            <a-select v-model="searchForm.state" allowClear placeholder="请选择状态" style="width: 100%">
              <a-select-option v-for="(value, key) in RECORD_STATE" :key="key" :value="key">{{
                value
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="优惠券类型" prop="coupon_type">
            <a-select v-model="searchForm.coupon_type" allowClear placeholder="请选择优惠券类型">
              <a-select-option v-for="(value, key) in COUPON_TYPE" :key="key" :value="key">
                {{ value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="优惠券ID" prop="coupon_id">
            <a-input v-model="searchForm.coupon_id" allowClear placeholder="请输入优惠券ID" style="width: 100%" />
          </a-form-item>
        </a-col>

        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="领取用户" prop="user_id">
            <StaffSelect v-model="searchForm.user_id" :disabled="!searchForm.project" :params="{ brand_id: Number(searchForm.project) }" :placeholder="searchForm.project? '请输入用户账号搜索':'请先选择发布平台'" notFoundText="用户不存在" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="">
            <a-button type="primary" icon="search" style="margin-right:18px" @click="search">查询</a-button>
            <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <div class="receive-statistics">
      <div>
        优惠种类： <span class="h-bold-text">{{ statistics.coupon_class_total }}</span> 个
      </div>
      <div>
        领取总额|总量： <span class="h-bold-text">{{ statistics.receive_amount | filterNumber }}</span> 元 | <span class="h-bold-text">{{ statistics.receive_total }}</span> 个
      </div>
      <div>
        使用总额 | 总量： <span class="h-bold-text">{{ statistics.user_amount | filterNumber }}</span> 元 | <span class="h-bold-text">{{ statistics.user_total }}</span>个
      </div>
    </div>

    <!-- 表格 -->
    <a-table
      size="middle"
      row-key="id"
      :columns="columns"
      :loading="loading"
      :data-source="data"
      :pagination="pagination"
      style="margin-top: 20px"
      @change="handleTableChange"
      :scroll="{ x: 1500, y: 'auto' }"
    >
      <template slot="project" slot-scope="text, record">
        <a-tag color="blue">{{ getLineName(record) }}</a-tag>
      </template>
      <!-- 领取用户 -->
      <template slot="receive_user" slot-scope="text, record">
        <template v-if="record.userInfo && record.userInfo.username">
          <a @click="handleDecryptReceiveUser(record)">{{ record.userInfo.username }}</a>
        </template>
        <template v-else>-</template>
      </template>

      <!-- 优惠券名称 -->
      <template slot="coupon_name" slot-scope="text, record">
        <a @click="jumpCouponDetail(record)">{{ record.couponSet.coupon_name }}</a>
      </template>

      <!-- 优惠券类型 -->
      <template slot="coupon_type" slot-scope="text, record">
        <div>{{ showName('COUPON_TYPE', record.couponSet.coupon_type) }}</div>
        <div class="gray-text-6 font12">
          {{ showName('COUPON_PROPERTY', record.couponSet.coupon_property) }}
        </div>
      </template>

      <!-- 优惠卷门槛 -->
      <template slot="threshold" slot-scope="text, record">
        <div>
          {{
            record.couponSet.coupon_type == 1 ? `${record.couponSet.coupon_amount}` : `${+record.couponSet.coupon_amount}折`
          }}
        </div>
        <div class="gray-text-6 font12">
          {{ record.couponSet.coupon_threshold == 0 ? '无门槛' : `满${+record.couponSet.coupon_threshold}可用` }}
        </div>
      </template>

      <!-- 领取/使用有效期 -->
      <template slot="rec_date_range" slot-scope="text, record">
        <div class="">
          <div>领取：{{ record.received_at | formatDate }}</div>
          <div>使用：{{ record.used_at | formatDate }}</div>
        </div>
      </template>

      <!-- 使用有效期 -->
      <template slot="use_date_range" slot-scope="text, record">
        <span v-if="record.couponSet.use_type == '1'">长期有效</span>
        <div class="" v-else-if="['2', '3'].includes(record.couponSet.use_type)">
          <div>开始：{{ record.valid_time_start | formatDate }}</div>
          <div>结束：{{ record.valid_time_end | formatDate }}</div>
        </div>
      </template>
      <!-- 领取状态 -->
      <template slot="state" slot-scope="text">
        <span :class="`state-${text}`">{{ showName('RECORD_STATE', text) }}</span>
      </template>
      领取方式
      <template slot="received_method" slot-scope="text, record">
        <template v-if="record.user_id === '0'">--</template>
        <template v-else>{{ showName('COUPON_WAY', record.couponSet.coupon_way) }}</template>
      </template>
      <template slot="operator" slot-scope="text, record">
        <a-button size="small" type="link" @click="handleDel(record)" v-if="['1', '2'].includes(record.state)"
        >删除</a-button
        >
        <a-button size="small" type="link" @click="handleRecovery(record)" v-if="['5'].includes(record.state)"
        >恢复</a-button
        >
      </template>
    </a-table>
  </div>
</template>
<script>
import moment from 'moment'

import { computed, reactive, onMounted, onUnmounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import pagination from '@/composables/pagination'
import computedFun from '@/views/coupon/computed/'
import api from '@/api/'
import { couponRecordList, couponOpera } from '@/api/coupon/index'
import { cloneDeep } from 'lodash'
import StaffSelect from '@/views/coupon/components/staffSelect'

const formReset = {
  project: undefined,
  coupon_name_keyword: undefined,
  coupon_code: undefined, // 优惠券码
  coupon_type: undefined,
  state: undefined,
  coupon_id: undefined,
  user_id: undefined,
}

const columns = [
  {
    title: '所属品牌',
    dataIndex: 'org',
    align: 'left',
    width: 90,
    scopedSlots: { customRender: 'project' }
  },
  {
    title: '优惠码',
    dataIndex: 'coupon_code',
    width: 180,
    align: 'center'
  },
  {
    title: '领取用户',
    dataIndex: 'receive_user',
    width: 140,
    align: 'center',
    scopedSlots: { customRender: 'receive_user' }

  },
  {
    title: '优惠券名称',
    dataIndex: 'coupon_name',
    width: 200,
    align: 'left',
    scopedSlots: { customRender: 'coupon_name' }
  },
  {
    title: '优惠券类型',
    dataIndex: 'type',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'coupon_type' }
  },
  {
    title: '面额/使用门槛',
    dataIndex: 'threshold',
    align: 'center',
    width: 200,
    scopedSlots: { customRender: 'threshold' }
  },
  {
    title: '使用有效期',
    dataIndex: 'use_date_range',
    align: 'left',
    width: 200,
    scopedSlots: { customRender: 'use_date_range' }
  },
  {
    title: '领取/使用时间',
    dataIndex: 'rec_date_range',
    align: 'left',
    width: 200,
    scopedSlots: { customRender: 'rec_date_range' }
    // customRender(text) {
    //   return parseTime(text)
    // }
  },
  {
    title: '使用状态',
    dataIndex: 'state',
    align: 'left',
    width: 90,
    scopedSlots: { customRender: 'state' }
  },
  {
    title: '使用订单编号',
    dataIndex: 'orders',
    align: 'left',
    width: 110,
    customRender(text, record) {
      let orderStr = "--"
      if (Array.isArray(record?.orders) && record.orders?.length) {
        // 退款不返还优惠券：则退款后订单号不清除，领取状态依旧保持 “已使用”
        if (record?.couponSet?.refund_rule === '1') {
          orderStr = record.orders.map(item => item.order_sn).join('；')
        } else {
          orderStr = record.orders.filter(item => item.cp_state === '1').map(item => item.order_sn).join('；')
        }
      }
      return orderStr
    }
  },
  {
    title: '领取方式',
    dataIndex: 'received_method',
    align: 'left',
    width: 110,
    scopedSlots: { customRender: 'received_method' }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 200,
    fixed: 'right',
    scopedSlots: { customRender: 'operator' }
  }
]

export default {
  components: { StaffSelect },
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      loading: false,
      visible: false,
      platformList: [], // 发布平台
      searchForm: cloneDeep(formReset),

      statistics: {
        coupon_class_total: 0, // 优惠券种类
        receive_amount: 0, // 优惠券领取金额合计
        receive_total: 0, // 优惠券领取数
        user_amount: 0, // 使用总额
        user_total: 0, // 使用总数
      },

      addRules: {
        project: [{ required: true, message: '请选择平台', trigger: 'blur' }]
      }
    })

    const lineListLv1 = computed(() => {
      return state.platformList.filter(item => {
        return item.depth === 0
      })
    })

    onMounted(() => {
      if (_this.$route.query.id) {
        state.searchForm.coupon_id = _this.$route.query.id
      }
      methods.getPlatform()
      methods.getList()
    })
    onUnmounted(async () => {})

    const methods = {
      getUseEndDate(days) {
        // return moment().add(Number(days), 'days').startOf('day').unix()
        return moment().add(Number(days), 'days').subtract(1, 'days').endOf('day').unix()
      },
      jumpCouponDetail(row) {
        const { project } = row
        const { href } = this.$router.resolve({
          name: 'couponDetail',
          params: {
            id: row.coupon_id
          },
          query: {
            project
          }
        })
        window.open(href, '_blank')
      },
      async decryptReceiveUser(id) {
        const res = await couponRecordList({
            id,
            page: 1,
            per_page: 1
          }, {
            is_enc: 'no',
          })
          return res
      },
      handleDecryptReceiveUser(record) {
        if (record.is_enc === 1) return
        methods.commonConfirm('确定查看用户加密信息？').then(async () => {
          const res = await methods.decryptReceiveUser(record.id)
          if (Array.isArray(res.data?.list) && res.data?.list.length && res.data.list[0].userInfo) {
            _this.$set(record, 'userInfo', res.data.list[0].userInfo)
          }
          record.is_enc = 1
        })
      },
      handleProjectChange() {
        this.searchForm.user_id = undefined
      },
      search() {
        _this.pagination.current = 1
        _this.getList()
      },
      async handleCouponRecordUpdateState(id, state) {
        if (!id) return
        await couponOpera({ id, state })
        _this.getList()
      },
      getSearchParams() {
        const queryParams = { ...state.searchForm }
        if (Array.isArray(queryParams.publish_at) && queryParams.publish_at.length === 2) {
          queryParams.start_date = moment
            .unix(queryParams.publish_at[0])
            .startOf('day')
            .unix()
          queryParams.end_date = moment
            .unix(queryParams.publish_at[1])
            .endOf('day')
            .unix()
        } else {
          delete queryParams.start_date
          delete queryParams.end_date
        }
        delete queryParams.publish_at
        return queryParams
      },
      async getList() {
        try {
          _this.loading = true
          const res = await couponRecordList({
            ...methods.getSearchParams(),
            page: _this.pagination.current,
            per_page: _this.pagination.pageSize
          })
          const { list, pagination, statistics } = res.data
          if (_this.pagination.current === 1) {
            _this.statistics = statistics
          }
          _this.data = list
          _this.pagination.total = +pagination.total
          _this.loading = false
        } catch (error) {
          _this.loading = false
        }
      },

      // 获取平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },
      // 发布平台
      getLineName(record) {
        return state.platformList.find(item => String(item.project) === String(record.project))?.org ?? '--'
      },

      // 清除
      handleClear() {
        state.searchForm = cloneDeep(formReset)
        _this.search()
      },

      commonConfirm(title, content) {
        return new Promise((resolve, reject) => {
          _this.$confirm({
            title,
            content,
            okText: '确定',
            cancelText: '取消',
            onOk: () => resolve(true),
            // eslint-disable-next-line prefer-promise-reject-errors
            onCancel: () => reject(false)
          })
        })
      },
      /**
       * 恢复
       */
      async handleRecovery(record) {
        // 有效期未过期或者长期有效（没过使用有效结束时间）
        // if (record.use_type === '1' || moment.unix(Number(record.use_eff_end_at)).valueOf() > Date.now()) {
        if (record.state !== '4') {
          await _this
            .commonConfirm('确定要恢复吗？')
            .then(async () => {
              const res = await methods.handleCouponRecordUpdateState(record.id, 2)
              if (_this.$validate(res)) {
                _this.$message.success(`恢复完成！`)
                methods.getList()
              }
            })
            .catch(() => {})
          // } else if (moment.unix(Number(record.use_eff_end_at)).valueOf() < Date.now()) {
        } else if (record.state === '4') {
          // 超过使用有效结束时间
          await _this
            .commonConfirm('该优惠券已过期，恢复后也不可用，确认恢复？')
            .then(async () => {
              const res = await methods.handleCouponRecordUpdateState(record.id, 2)
              if (_this.$validate(res)) {
                _this.$message.success(`恢复完成！`)
                methods.getList()
              }
            })
            .catch(() => {})
        }
      },
      async handleDel(record) {
        await _this
          .commonConfirm('确定要删除吗？')
          .then(async () => {
            const res = await methods.handleCouponRecordUpdateState(record.id, 5)
            if (_this.$validate(res)) {
              _this.$message.success(`删除成功！`)
              methods.getList()
            }
          })
          .catch(() => {})
      }
    }

    return {
      lineListLv1,
      ...toRefs(state),
      ...computedFun(),
      ...pagination(),
      ...methods
    }
  }
}
</script>
<style lang="less">
.state {
  &-0 {
    color: #f59a23;
  }
  &-1 {
    color: #f59a23;
  }
  &-2 {
    color: #f59a23;
  }
  &-3 {
    color: #1fb749;
  }
  &-4 {
    color: #555555;
  }
  &-5 {
    color: #555555;
  }
  &-6 {
    color: 555555;
  }
}
.receive-statistics {
  // overflow: hidden;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  transition: .3s;
  padding: 16px 0px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 16px;
  &:hover {
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }

  .h-bold-text {
    color: #FB8C00;
    font-size: 20px;
    font-weight: 700;
  }
}
</style>
